import { ReactNode } from "react";

interface ActiveGameZoneScreenProps {
  /** Контент/віджети екрану */
  children: ReactNode;
}

/**
 * Базовий компонент для екранів з активною зоною гри (без навігації).
 * Забезпечує активну зону з пропорціями (9:16 для мобільних, 3:4 для планшетів)
 * та чорний фон по боках на широких екранах.
 * Вся структура та стилі мають бути описані в children.
 */
export default function ActiveGameZoneScreen({
  children,
}: ActiveGameZoneScreenProps) {
  return (
    <div className="relative flex h-full w-full select-none items-center justify-center bg-black">
      <div className="screen-active-zone relative h-full w-auto max-w-[100vw] min-w-0 select-none overflow-visible">
        <style>{`
          .screen-active-zone {
            aspect-ratio: 9/16;
            @media (min-width: 768px) {
              aspect-ratio: 3/4;
            }
          }
        `}</style>
        {children}
      </div>
    </div>
  );
}
